import type { ReactNode } from "react"

import { useXPositionAsTime } from "../hooks"
import { TooltipContext } from "./TooltipContext"
import type { TooltipOptions } from "./TooltipOptions"
import { TooltipPortal } from "./TooltipPortal"
import { useMouseX } from "./useMouseX"
import { useTooltip } from "./useTooltip"
import { useFollowedUsers } from "src/contexts"
import { useNearestGlucoseReading } from "src/hooks"

interface Props extends TooltipOptions {
  children: ReactNode;
}

/*
 * this component provides the tooltip context for its children and renders the tooltip portal
 */
export function TooltipContextProvider({
  children, ...options
}: Props) {
  const { currentFollow } = useFollowedUsers()
  const mouseX = useMouseX()
  const time = useXPositionAsTime(mouseX)
  const reading = useNearestGlucoseReading(
    currentFollow.following_account_id,
    time,
  )

  // This can accept any props as options, e.g. `placement`,
  // or other positioning options.
  const tooltip = useTooltip({
    ...options,
    reading,
  })

  return (
    <TooltipContext.Provider value={tooltip}>
      {children}
      <TooltipPortal />
    </TooltipContext.Provider>
  )
}
